import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import {
  Box,
  Typography,
  TextField,
  Select,
  MenuItem,
  Button,
  List,
  ListItem,
  InputAdornment,
  Divider,
  FormControl,
  InputLabel,
  IconButton,
  Pagination,
  Tooltip,
  Autocomplete,
  Dialog,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import "./ChecklistQuestionBankCss/ChecklistQuestionBank.css";
import {
  ApiGetChecklistCategoryList,
  ApiGetChecklistQuestions,
  ApiGetQuestionUsage,
  GetCategories,
  GetEntities,
  GetQuestions,
} from "../../../../apiService/Core/Apicall.tsx";
import edit from "../../../../assets/images/editIcon.png";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { CancelOutlined, Info } from "@mui/icons-material";

const limit = 20;
const ChecklistQuestionBank: React.FC = () => {
  const [questionBank, setquestionBank] = useState<any>([]);
  const [category, setcategorey] = useState<any>([]);
  const [selectedcategory, setSelectedcategorey] = useState<number | string>(0);
  const [entity, setentity] = useState<any>("");
  const [searchTerm, setSearchTerm] = useState<string>("");
  const [selectedentity, setselectedentity] = useState<number | string>(0);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [total, setTotal] = useState<number>(0);
  const [openQuestionUsage, setOpenQuestionUsage] = useState<boolean>(false)
  const [questionUsageList, setQuestionUsageList] = useState<any>([])
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState(searchTerm);
  

  const navigate = useNavigate();
  useEffect(() => {
    const fetchcategory = async () => {
      try {
        const data =`?isActive=true`
        const categories = await ApiGetChecklistCategoryList(data);
        setcategorey(categories.data);
      } catch (error) {
        toast.error(error);
      }
    };

    const fetchentities = async () => {
      try {
        const entities = await GetEntities();
        setentity(entities.data);
      } catch (error) {
        toast.error(error);
      }
    };
    fetchcategory();
    fetchentities();
  }, []);
  function decodeHtml(html) {
    const txt = document.createElement("textarea");
    txt.innerHTML = html;
    return txt.value;
  }
  useEffect(() => {
    const fetchquestionbank = async () => {
      const offset = (currentPage - 1) * limit;
      const data = `?offset=${offset}&limit=${limit}${selectedcategory ? `&checklistCategoryId=${selectedcategory}`:""}&isActive=true${debouncedSearchTerm ? `search=${debouncedSearchTerm}`: ""}`
      try {
        const response = await ApiGetChecklistQuestions(data);
        setquestionBank(response.data);
        setTotal(response.totalCount);
        console.log(response.data);
      } catch (error:any) {
        toast.error(error?.message || "spmething went wrong");
      }
    };
    fetchquestionbank();
  }, [currentPage, selectedcategory, selectedentity, debouncedSearchTerm]);

useEffect(() => {
    const timer = setTimeout(() => {
        setDebouncedSearchTerm(searchTerm);
    }, 500); // 500ms delay

    return () => clearTimeout(timer);
}, [searchTerm]);


  const totalPages = Math.ceil(total / limit);

  const filteredQuestions = questionBank
  // .filter((q) =>
  //   q.questions.toLowerCase().includes(searchTerm.toLowerCase())
  // );

  const getQuestionUsage = async (questionId: number | string) => {
    try {
      const data = `?questionId=${questionId}`
      const res = await ApiGetQuestionUsage(data)
      if (res?.status) {
        setQuestionUsageList(res?.data)
        setOpenQuestionUsage(true)
      }
    } catch (error: any) {
      toast.error(error?.messsage)
    }
  }
  return (
    <Box
      className="container-fluid p-3 extra"
      bgcolor="white"
      minHeight="calc(100vh - 180px)"
    >
      {/* Top Bar */}
      <Box className="d-flex justify-content-between w-100 py-2">
        <Typography variant="h6">
          {" "}
          {/* Push title to the left */}
          Checklist Question Bank
        </Typography>
        <Box
          className=" justify-content-end col-5 d-flex align-items-center"
          gap={2}
        >
          {/* <FormControl className="col-4">
            <Select
              id="demo-simple-select"
              value={selectedentity}
              onChange={(e) => setselectedentity(e.target.value)}
            >
              <MenuItem value={0} selected>
                Select Type
              </MenuItem>

              {entity.length > 0 &&
                entity.map((cat) => (
                  <MenuItem value={cat.entityTypeId} key={cat.entityTypeId}>
                    {cat.entityTypeName}
                  </MenuItem>
                ))}
            </Select>
          </FormControl> */}
          <FormControl className="col-4">
            {/* <Select
              id="demo-simple-select"
              value={selectedcategory}
              onChange={(e) => setSelectedcategorey(e.target.value)}
            >
              <MenuItem value={0}>Select Category</MenuItem>
              {category.length > 0 &&
                category.map((cat) => (
                  <MenuItem value={cat.categoryId} key={cat.categoryId}>
                    {cat.categoryName}
                  </MenuItem>
                ))}
            </Select> */}

            <Autocomplete
              size="small"
              options={category || []}
              getOptionLabel={(option) => option.categoryName || ""}
              isOptionEqualToValue={(option, value) =>
                option.checklistCategoryId === value.checklistCategoryId
              }
              value={
                category?.find(
                  (item) => item.checklistCategoryId === selectedcategory
                ) || null
              }
              onChange={(event, newValue) => {
                setSelectedcategorey(
                  newValue ? newValue.checklistCategoryId : 0
                );
              }}
              sx={{
                "& .MuiOutlinedInput-root": {
                  padding: "0px",
                  minHeight: "32px",
                },
                "& .MuiAutocomplete-input": {
                  padding: "6px 8px !important",
                },
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  size="small"
                  placeholder="Select Category"
                  InputLabelProps={{ shrink: undefined }}
                />
              )}
              fullWidth
            />

          </FormControl>

          <Link
            to='/admin/checklist/create-new-question'

            className="link-btn"
            style={{ lineHeight: 'normal' }}
          >
            + Add New
          </Link>
          {/* <Button
            onClick={() => {
              navigate("/admin/create-new-question");
            }}
            className="bg-grey transform text-light px-4 py-1"
          >
            + Add New
          </Button> */}
        </Box>
      </Box>
      <Divider className="w-100 my-2 mb-3" />
      <TextField
        className="search-bar  mb-3"
        placeholder="Search your Question here..."
        variant="outlined"
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
        fullWidth
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon style={{ color: "black" }} />
            </InputAdornment>
          ),
        }}
      />
      {filteredQuestions.length > 0 &&
        filteredQuestions.map((question) => (
          <Box key={question.questionId} className="question-box">
            <Box className="question-header">
              <Box className="d-flex col-8 gap-5 align-items-center p-0">
                <Typography style={{ color: "#747247" }}>
                  {" "}
                  Question ID: #{question.checklistQuestionId}
                </Typography>
                <Typography> &nbsp; | &nbsp; </Typography>
                <Typography sx={{ fontWeight: "bold" }}>
                  Category: {question?.checklistCategoryId?.categoryName}
                </Typography>
                <Typography> &nbsp; | &nbsp; </Typography>
                <Typography sx={{ fontWeight: "bold" }}>
                  Type:{" "}
                  {question.qType.length > 0
                    ? question.qType === "R"
                      ? "Radio"
                      : question.qType === "r"
                        ? "Radio Rating"
                        : question.qType === "C"
                          ? "CheckBox"
                          : "Text"
                    : "notFound"}
                </Typography>
                <Typography> &nbsp; | &nbsp; </Typography>
              </Box>

              <Box className="d-flex p-0 col-4 gap-3  align-items-center">
                {question?.isPhotoRequire && (
                  <Box className="ml-auto">
                    <Box
                      className="images-tag ml-auto px-4 py-2"
                      width="fit-content"
                    >
                      <Typography>Images - Min: {question.minPhoto}</Typography>
                    </Box>
                  </Box>
                )}
                {/* <Box
                  className="images-tag ml-auto  px-4 py-2"
                  width="fit-content"
                >
                  <Typography>{question.questionGroup}</Typography>
                </Box> */}
                <Box className="version-tag col-4 p-0 justify-content-end">
                  {/* <Box className="d-flex" bgcolor="#D3D3D3" borderRadius="5px">
                    <Typography
                      className="p-2 px-3 text-center col-6"
                      whiteSpace={"nowrap"}
                    >
                      {(question?.entityTypeId &&
                        question.entityTypeId.entityTypeName) ||
                        "undefined"}
                    </Typography>
                  </Box> */}
                  {/* <IconButton
                    className="col-4"
                    onClick={() => {
                      navigate(`/admin/create-new-question`, {
                        state: { questionData: question },
                      });
                    }}
                  >
                    <Box component="img" src={edit} className="w-50"></Box>
                  </IconButton> */}
                  <Link
                    className="col-4"
                    style={{ cursor: 'pointer' }}
                    to={`/admin/checklist/create-new-question/${question?.checklistQuestionId}`}

                  >
                    <Box component="img" src={edit} className="w-100" minWidth={'20px'} maxWidth={'30px'}></Box>
                  </Link>
                  {/* <Button onClick={() => { getQuestionUsage(question.questionId) }} className="link-btn whitespace text-white" sx={{ textTransform: 'none' }}>
                    Usage
                  </Button> */}
                </Box>
              </Box>
            </Box>
            <Box>
              <Typography
                className="d-flex"
                sx={{ fontWeight: "bold" }}
                variant="body1"
                mt={1}
              >
                Q: &nbsp;{" "}
                <span
                  dangerouslySetInnerHTML={{ __html: question.question}}
                />
              </Typography>
              {question.qOptionJson !== null &&
                question.qOptionJson.trim() !== "" ? (
                <List
                  component="ol"
                  className="question-options w-100 d-flex justify-content-between flex-wrap"
                >
                  {(() => {
                    try {
                      const parsedOptions = JSON.parse(question.qOptionJson);
                      return parsedOptions.map((option, index) => (
                        <ListItem key={index} className="col-6 option-text">
                          <span>{index + 1}. &nbsp;</span>
                          <span
                            dangerouslySetInnerHTML={{ __html: option.value }}
                          />&nbsp;
                          <span>(<span dangerouslySetInnerHTML={{ __html: option.optionScore }} />)</span>
                          {option.radioRatingComment && (
                            <span className="ml-1">
                              ({option.radioRatingComment})
                            </span>
                          )}
                          <Tooltip
                            title={
                              <Box>
                                <Typography variant='caption' display={'block'}><b>optionComment: </b> {option?.optionComment}</Typography>
                                <Typography variant='caption' display={'block'}><b>minChar: </b> {option?.minChar}</Typography>
                                <Typography variant='caption' display={'block'}><b>optionCommentType: </b> {option?.optionCommentType ?? "N/A"}</Typography>
                                <Typography variant='caption' display={'block'}><b>is Pass: </b> {option?.isPass ? "true": "false"}</Typography>
                                {option?.optionImage > 0 && (<Typography variant='caption' display={'block'}><b>optionImage: </b>{option?.optionImage}</Typography>)}
                              </Box>
                            }
                          >
                            <Info sx={{ fontSize: '16px', marginLeft: "8px" }} />
                          </Tooltip>
                        </ListItem>
                      ));
                    } catch (error) {
                      console.error("Invalid JSON in qOptionJson:", error);
                      return (
                        <Typography className="option-text text-danger">
                          Error: Invalid JSON format
                        </Typography>
                      );
                    }
                  })()}
                </List>
              ) : (
                <Typography className="option-text">
                  {question.options
                    ? question.options[0]
                    : "Answer will be a manual Text Entry."}
                </Typography>
              )}
              <Typography className="d-flex">
                Description: &nbsp;
                <span
                  dangerouslySetInnerHTML={{
                    __html: decodeHtml(question.questionDescription),
                  }}
                />
                {/* {question.questionDescription} */}
              </Typography>
              <Typography className="d-flex">
                Hint: &nbsp;
                <span
                  dangerouslySetInnerHTML={{
                    __html: decodeHtml(question.questionHint),
                  }}
                />
              </Typography>
            </Box>
          </Box>
        ))}
      <Pagination
        className="d-flex justify-content-center"
        count={totalPages} // Total pages
        page={currentPage} // Current page
        onChange={(event, value) => setCurrentPage(value)} // Page change handler
      />

      <Dialog fullWidth open={openQuestionUsage}>
        <Box className='d-flex align-items-center justify-content-between p-3'>
          <Typography className="fw-bold" variant="h5">Question Usage</Typography>
          <IconButton onClick={() => { setOpenQuestionUsage(false); setQuestionUsageList([]); }}>
            <CancelOutlined />
          </IconButton>
        </Box>
        <Box className='p-3'>
          {questionUsageList?.businessUsage?.length > 0 && (
            <Box className='mb-3'>
              <Typography variant="h6">Businesses</Typography>
              <List sx={{ listStyleType: "disc", pl: 4 }}>
                {
                  questionUsageList?.businessUsage?.map((item: any, index: number) => (
                    <ListItem key={index}
                      className="px-0"
                      sx={{ display: "list-item !important", listStyle: 'outside', py: 0 }}>
                      <Link
                        to={`/admin/create-client-template/${item?.clientEntityId}`}
                        // className="table-row-background fs-14 link-btn"
                        style={{ textDecoration: "underline !important", color: "#75724C" }}
                        target="__blank"
                      > {item?.entityName}
                      </Link>
                    </ListItem>
                  ))
                }
              </List>
            </Box>
          )}

          {questionUsageList?.venueUsage?.length > 0 && (
            <Box className='mb-3'>
              <Typography variant="h6">Sites</Typography>
              <List component="ul" sx={{ listStyleType: "disc", pl: 4 }}>
                {
                  questionUsageList?.venueUsage?.map((item: any, index: number) => (
                    <ListItem key={index}
                      className="px-0"
                      sx={{ display: "list-item", listStyle: 'outside', py: 0 }}>
                      <Link
                        to={`/admin/create-venue-site-template/${item?.venueId}`}
                        // onClick={() => navigateToVenueSiteQuestion(venue)}
                        style={{ textDecoration: "underline !important", color: "#75724C" }}
                        target="__blank"
                      >
                        {item?.venueName}
                      </Link>
                    </ListItem>
                  ))
                }
              </List>
            </Box>
          )}
          {questionUsageList?.templateUsage?.length > 0 && (
            <Box className='mb-3'>
              <Typography variant="h6">Question Template</Typography>
              <List component="ul" sx={{ listStyleType: "disc", pl: 4 }}>
                {
                  questionUsageList?.templateUsage?.map((item: any, index: number) => (
                    <ListItem key={index}
                      className="px-0"
                      sx={{ display: "list-item", listStyle: 'outside', py: 0 }}>
                      <Link to={`/admin/create-new-template/${item?.templateName}/${item?.entityTypeTemplateId}`}
                        style={{ textDecoration: "underline !important", color: "#75724C" }}
                        target="__blank"

                      >
                        {item?.templateName}</Link>
                    </ListItem>
                  ))
                }
              </List>
            </Box>
          )}
        </Box>
      </Dialog>
    </Box>
  );
};

export default ChecklistQuestionBank;
